import { finalize } from 'rxjs/operators';
import { TableDataSource } from 'app/layout/components/table/table.datasource';
import { QuotesService } from './quotes.service';
import { Quote } from 'app/entities/quote';

export class QuotesDatasource extends TableDataSource<Quote> {
  isStatic = false;

  constructor(private service: QuotesService, staticDatasource: boolean = false) {
    super();
    this.isStatic = staticDatasource;
  }

  load(params: any) {
    if (this.isStatic) return;
    this.loadingSubject.next(true);
    this.service
      .findAll(params)
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe((result) => {
        const quotes = result.data ?? [];
        this.totalItemsSubject.next(result.meta?.total ?? 0);
        this.itemsSubject.next(quotes);
        this.emptySubject.next((quotes?.length ?? 0) <= 0);
        this.noRecordsSubject.next((quotes?.length ?? 0) <= 0 && Object.keys(params?.filter?.filters).filter((x) => params?.filter?.filters[x]?.length > 0).length == 0);
      });
  }

  setValue(proposals: Quote[]) {
    this.itemsSubject.next(proposals);
  }
}
